import { render, staticRenderFns } from "./BookingHeader.vue?vue&type=template&id=2ca98cec"
import script from "./BookingHeader.vue?vue&type=script&lang=ts"
export * from "./BookingHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports